import { useReducer } from "react"

const initialState = {
    anyLoading: false,
    data: {
        fluxoEventos: {
            CETIP: null,
            Versoes: [],
            VersaoDocumento: null,
            EventosOrdinarios: [],
            EventosExtraordinarios: [],
            Premio: [],
            Conversibilidade: [],
        },
    },
    error: {
        fluxoEventos: {
            isError: false,
            message: "",
        },
    },
    loading: {
        fluxoEventos: false,
    },
}

function reducer(state, action) {
    switch (action.type) {
        case "SET_LOADING": {
            const newLoading = { ...state.loading, [action.key]: action.payload }
            const anyLoading = Object.values(newLoading).some(Boolean)
            return { ...state, loading: newLoading, anyLoading }
        }
        case "SET_DATA":
            return {
                ...state,
                data: { ...state.data, [action.key]: action.payload },
                error: { ...state.error, [action.key]: {} },
            }
        case "SET_ERROR":
            return { ...state, error: { [action.key]: action.payload } }
        default:
            return state
    }
}

const isVersaoInformada = (versaoDocumento) =>
    versaoDocumento !== undefined && versaoDocumento !== null && versaoDocumento !== ""

export const useFluxoEventosMotor = (eventosFluxoService, cetip) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    const loadFluxoEventos = async (cetipParam, versaoDocumento) => {
        const cetipConsulta = cetipParam ?? cetip

        if (!cetipConsulta || cetipConsulta === "") {
            dispatch({
                type: "SET_ERROR",
                key: "fluxoEventos",
                payload: { isError: true, message: "empty cetip value receive" },
            })
            return
        }

        dispatch({ type: "SET_LOADING", key: "fluxoEventos", payload: true })

        try {
            const versaoParaEnvio = isVersaoInformada(versaoDocumento) ? versaoDocumento : undefined

            const response = await eventosFluxoService.getFluxoEventos(cetipConsulta, versaoParaEnvio)
            const { body } = response

            if (typeof body === "string") {
                dispatch({
                    type: "SET_ERROR",
                    key: "fluxoEventos",
                    payload: { isError: true, message: body },
                })
                return body
            }

            dispatch({ type: "SET_DATA", key: "fluxoEventos", payload: body })
            return body
        } catch (e) {
            dispatch({
                type: "SET_ERROR",
                key: "fluxoEventos",
                payload: { isError: true, message: e },
            })
        } finally {
            dispatch({ type: "SET_LOADING", key: "fluxoEventos", payload: false })
        }
    }

    return {
        state,
        actions: {
            loadFluxoEventos,
        },
    }
}